import React, { useState, useEffect, useRef } from 'react';
import { FaPills, FaUserMd, FaCalendarAlt } from 'react-icons/fa';
import { getCaracteristicas } from '../services/caracteristicasService';
import partnerTratamientoService from '../services/partnerTratamientoService';
import requisitosService from '../services/requisitosService';
import sociasRequisitosService from '../services/sociasRequisitosService';
import sociasCaracteristicasService from '../services/sociasCaracteristicasService';
import TratamientoModal from '../components/TratamientoModal';
import CarnetModal from '../components/CarnetModal';
import CarnetDirectorModal from '../components/CarnetDirectorModal';
import FormatCarnetModal from '../components/FormatCarnetModal';
import SolicitudIngresoModal from '../components/SolicitudIngresoModal';
import carnetService from '../services/carnetService';
import authService from '../services/authService';

import TallaModal from '../components/TallaModal';

import { useNavigate } from 'react-router-dom';
import '../styles/PartnersList.css';
import sociasApiService from '../services/sociasApiService';
import profesionService from '../services/profesionService';
import { getTiposSocia } from '../services/tiposSociaService';
import tallaService from '../services/tallaService';

const PartnersList = () => {
    const navigate = useNavigate();
    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(true);
    // Eliminado error: no se usa
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedPartner, setSelectedPartner] = useState(null);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showTallaModal, setShowTallaModal] = useState(false);
    const [showRequisitosModal, setShowRequisitosModal] = useState(false);
    const [showRasgosModal, setShowRasgosModal] = useState(false);
    const [showTratamientoModal, setShowTratamientoModal] = useState(false);
    const [showTratamientoDetailModal, setShowTratamientoDetailModal] = useState(false);
    const [selectedTratamiento, setSelectedTratamiento] = useState(null);
    const [showSolicitudIngresoModal, setShowSolicitudIngresoModal] = useState(false);
    const [showCarnetModal, setShowCarnetModal] = useState(false);
    const [showCarnetDirectorModal, setShowCarnetDirectorModal] = useState(false);

    const carnetDirectorDataRef = useRef({ nombreDirectora: '', cedulaDirectora: '' }); // eslint-disable-line no-unused-vars
    const [carnetBlob, setCarnetBlob] = useState(null);
    const [carnetLoading, setCarnetLoading] = useState(false);
        // Eliminado estado no usado: carnetError
    const [caracteristicas, setCaracteristicas] = useState([]);
    const [tratamientos, setTratamientos] = useState([]);
    const [loadingTratamientos, setLoadingTratamientos] = useState(false);
    const [requisitos, setRequisitos] = useState([]);
    const [loadingRequisitos, setLoadingRequisitos] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [_profesionesMap, setProfesionesMap] = useState(new Map());
    // eslint-disable-next-line no-unused-vars
    const [_tiposSociaMap, setTiposSociaMap] = useState(new Map());
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    // Estados de edición y temporales para edición
    const [editRequisitos, setEditRequisitos] = useState(false);
    const [editRasgos, setEditRasgos] = useState(false);
    const [tempRequisitos, setTempRequisitos] = useState([]);
    const [tempRasgos, setTempRasgos] = useState([]);
    const [showFormatModal, setShowFormatModal] = useState(false);
    const pendingCarnetRef = useRef(null);
    const isAdmin = React.useMemo(() => (
        authService.hasPermission('Administrador') || authService.hasPermission('CRUD Formato Carnet')
    ), []);

    // Cargar características reales al abrir el modal de Rasgos
    useEffect(() => {
        if (!showRasgosModal) return;
        (async () => {
            try {
                const res = await getCaracteristicas();
                const arr = Array.isArray(res?.data) ? res.data : (Array.isArray(res?.data?.data) ? res.data.data : []);
                const normalized = arr
                    .map((it) => ({
                        id: String(it.CARACTERISTICA_ID || it.id || it.ID || ''),
                        nombre: it.CARACTERISTICA_NOMBRE || it.nombre || it.name || '',
                        observacion: it.CARACTERISTICA_OBSERVACION || it.observacion || it.observation || '',
                    }))
                    .filter((it) => it.id && it.nombre);
                setCaracteristicas(normalized);
            } catch (e) {
                // Fallback mínimo si API no está lista
                setCaracteristicas([
                    { id: '1', nombre: 'Baja estatura', observacion: 'Común en el síndrome' },
                    { id: '2', nombre: 'Cuello ancho', observacion: 'Pterigium colli' },
                    { id: '3', nombre: 'Implantación baja de cabello', observacion: '' },
                ]);
            }
        })();
    }, [showRasgosModal]);

    // Cargar requisitos del catálogo y los entregados por la socia al abrir el modal
    useEffect(() => {
        if (!showRequisitosModal || !selectedPartner?.id) return;
        const loadRequisitosAndEntregados = async () => {
            setLoadingRequisitos(true);
            try {
                // 1) Catálogo completo
                const requisitosData = await requisitosService.getAllRequisitos();
                const requisitosFormateados = (requisitosData || []).map(req => ({
                    id: req.id,
                    nombre: req.nombre,
                    descripcion: req.descripcion
                }));
                setRequisitos(requisitosFormateados);

                // 2) Entregados desde backend (por nombre) y mapear a IDs del catálogo
                const entregadosRes = await sociasRequisitosService.listBySocia(selectedPartner.id);
                const nombresEntregados = Array.isArray(entregadosRes)
                  ? entregadosRes.map(r => r.REQUISITOS_NOMBRE || r.requisito || r.nombre).filter(Boolean)
                  : [];
                const mapNombreAId = new Map(requisitosFormateados.map(r => [r.nombre, r.id]));
                const idsEntregados = nombresEntregados.map(n => mapNombreAId.get(n)).filter(Boolean);

                // Actualizar en el partner seleccionado y en la lista
                setPartners(prev => prev.map(socia =>
                    socia.id === selectedPartner.id
                        ? { ...socia, requisitosEntregados: idsEntregados }
                        : socia
                ));
                setSelectedPartner(prev => prev ? { ...prev, requisitosEntregados: idsEntregados } : prev);

                // Si está en modo edición, preparar temp
                if (editRequisitos) {
                    setTempRequisitos([...idsEntregados]);
                }
            } catch (error) {
                console.error('Error cargando requisitos/entregados:', error);
            } finally {
                setLoadingRequisitos(false);
            }
        };
        loadRequisitosAndEntregados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showRequisitosModal, selectedPartner?.id]);

// Para demo: función para obtener características mock (en real, usar API)
// Eliminado arreglo mock no usado (caracteristicasMock)

    // Cargar catálogos base (profesiones y tipos de socia) y luego socias desde la API
    useEffect(() => {
        const fetchSocias = async () => {
            try {
                setLoading(true);
                // Cargar en paralelo: socias + catálogos para mostrar nombres legibles
                const [data, profesionesData, tiposRes] = await Promise.all([
                    sociasApiService.getSocias(),
                    profesionService.getAllProfesiones().catch(() => []),
                    getTiposSocia().catch(() => ({ data: [] }))
                ]);
                // Construir mapas id -> nombre (robustos a distintas formas)
                const profMap = new Map(
                    (Array.isArray(profesionesData) ? profesionesData : []).map((p) => [
                        String(p.PROFESION_ID || p.id || p.Id || p.professionId || ''),
                        p.PROFESION_NOMBRE || p.nombre || p.name || ''
                    ]).filter(([, nombre]) => !!nombre)
                );
                const tiposArr = Array.isArray(tiposRes?.data) ? tiposRes.data : (Array.isArray(tiposRes) ? tiposRes : []);
                const tsMap = new Map(
                    tiposArr.map((t) => [
                        String(t.TS || t.id || t.tipoSociaId || ''),
                        t.TIPOSOCIA_NOMBRE || t.nombre || t.name || ''
                    ]).filter(([, nombre]) => !!nombre)
                );
                setProfesionesMap(profMap);
                setTiposSociaMap(tsMap);
                console.log('📋 Datos recibidos del API:', data); // Debug
                
                // Adaptar datos del API al formato esperado por el componente
                const adaptedData = data.map(socia => {
                    console.log(`Socia ${socia.sociaId} - mentorDisplay:`, socia.mentorDisplay); // Debug
                    // Ahora la foto viene como URL de Cloudinary, no como Base64
                    const fotoDataUri = socia.sociaFotoUrl || null;
                    // Resolver nombres legibles para profesión y tipo de socia
                    const profesionNombre = (
                        socia.profesionNombre ||
                        profMap.get(String(socia.profesionId)) ||
                        socia.profesion ||
                        'No especificada'
                    );
                    const tipoSociaNombre = (
                        socia.tipoSociaNombre ||
                        tsMap.get(String(socia.ts || socia.tipoSociaId)) ||
                        socia.tsNombre ||
                        'No especificado'
                    );
                    return {
                        id: socia.sociaId,
                        datosPersonales: {
                            nombres: socia.sociaNombre,
                            apellidos: socia.sociaApellido,
                            cedula: socia.sociaCedula,
                            edad: socia.sociaEdad,
                            fechaNacimiento: socia.sociaFechaNacimiento,
                            estadoCivil: socia.sociaEstadoCivil,
                            nacionalidad: socia.sociaNacionalidad,
                            profesion: profesionNombre,
                            sexo: socia.sociaSexo,
                            tipoSocio: tipoSociaNombre,
                            foto: fotoDataUri
                        },
                        datosUbicacion: {
                            pais: socia.sociaPais,
                            ciudadDistrito: socia.sociaCiudad,
                            provinciaRegion: socia.sociaProvincia,
                            sectorBarrio: socia.sociaSector,
                            direccion: socia.sociaDireccion,
                            correoElectronico: socia.sociaEmail,
                            telefono1: socia.sociaTelefono1,
                            telefono2: socia.sociaTelefono2
                        },
                        datosMedicos: {
                            tipoSindrome: socia.sociaTipoSindrome || 'No especificado',
                            estado: socia.sociaEstado,
                            cariotipo: socia.sociaCariotipo,
                            carnetDiscapacidad: socia.sociaCarnetDiscapacidad,
                            tipoDiscapacidad: socia.sociaTipoDiscapacidad,
                            porcentajeDiscapacidad: socia.sociaPorcentajeDiscapacidad,
                            grado: socia.sociaGrado,
                            iees: socia.sociaIees,
                            edadDeteccion: socia.sociaEdadDeteccion,
                            hormonaCrecimiento: socia.sociaHormonaCrecimiento,
                            msp: socia.sociaMsp,
                            talla: socia.sociaTalla,
                            // Derivado y fechas
                            padeceSindrome: (socia.sociaTipoSindrome && String(socia.sociaTipoSindrome).trim().toLowerCase() !== 'n/a') ? 'Sí' : 'No',
                            fechaInscripcion: socia.sociaFechaInscripcion,
                            mentor: socia.mentorDisplay || 'No asignado',
                            linkDocumentos: socia.sociaLinkDocumentos || ''
                        },
                        redesSociales: {
                            facebook: socia.sociaRfacebook,
                            instagram: socia.sociaRinstagram,
                            x: socia.sociaRx
                        },
                        representante: {
                            tieneRepresentante: socia.sociaRepresentante,
                            cedula: socia.sociaRepresentanteCedula,
                            nombre: socia.sociaRepresentanteNombre
                        },
                        // Mantener todos los datos originales para compatibilidad
                        ...socia
                    };
                });
                
                setPartners(adaptedData);
            } catch (error) {
                console.error('Error al cargar socias:', error);
                setPartners([]);
            } finally {
                setLoading(false);
            }
        };
        
        fetchSocias();
    }, []);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const filteredPartners = partners.filter(partner => {
        const searchFields = [
            partner.datosPersonales.nombres,
            partner.datosPersonales.apellidos,
            partner.datosPersonales.cedula,
            partner.id
        ];
        return searchFields.some(field => 
            field.toLowerCase().includes(searchTerm.toLowerCase())
        );
    });

    const total = filteredPartners.length;
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    const paginatedPartners = filteredPartners.slice((page - 1) * pageSize, page * pageSize);

    const handleAddPartner = () => {
        navigate('/register-partner');
    };

    const handleEdit = (id) => {
        navigate(`/register-partner/${id}`);
    };

    const handleShowDetails = (partner) => {
        setSelectedPartner(partner);
        setShowDetailModal(true);
        // Cargar tratamientos para este paciente
        loadTratamientos(partner.id);
        // Cargar talla más reciente para mostrar en el detalle
        loadTallaForPartner(partner);
    };

    // Función para cargar tratamientos del paciente seleccionado
    const loadTratamientos = async (pacienteId) => {
        if (!pacienteId) return;
        
        setLoadingTratamientos(true);
        try {
            const result = await partnerTratamientoService.getTratamientosResumen(pacienteId);
            if (result.success) {
                setTratamientos(result.data || []);
            } else {
                setTratamientos([]);
                console.error('Error al cargar tratamientos:', result.error);
            }
        } catch (error) {
            setTratamientos([]);
            console.error('Error al cargar tratamientos:', error);
        } finally {
            setLoadingTratamientos(false);
        }
    };

    // Función para navegar a crear tratamiento para una socia específica
    const handleNavigateToTratamientos = (partner) => {
        setSelectedPartner(partner);
        setShowTratamientoModal(true);
    };

    // Función para ver todos los tratamientos de una socia
    const handleVerTodosTratamientos = (partner) => {
        navigate('/tratamientos', { 
            state: { 
                pacienteId: partner.id,
                pacienteNombre: `${partner.datosPersonales.nombres} ${partner.datosPersonales.apellidos}`
            }
        });
    };

    // Función para ver detalle de un tratamiento
    const handleVerDetalleTratamiento = (tratamiento) => {
        setSelectedTratamiento(tratamiento);
        setShowTratamientoDetailModal(true);
    };

    // Cargar la talla más reciente de la socia y actualizar en el detalle
    const loadTallaForPartner = async (partner) => {
        try {
            if (!partner?.id) return;
            const resp = await tallaService.getTallasBySocia(partner.id);
            if (resp?.success && Array.isArray(resp.data) && resp.data.length > 0) {
                const sorted = [...resp.data].sort((a, b) => new Date(b.FECHA_REGISTRO) - new Date(a.FECHA_REGISTRO));
                const ultima = sorted[0];
                setSelectedPartner(prev => prev && prev.id === partner.id
                    ? { ...prev, datosMedicos: { ...prev.datosMedicos, talla: `${ultima.TALLA_CM} cm` } }
                    : prev
                );
            } else {
                // Fallback a cualquier valor existente en la socia
                if (partner.sociaTalla) {
                    setSelectedPartner(prev => prev && prev.id === partner.id
                        ? { ...prev, datosMedicos: { ...prev.datosMedicos, talla: `${partner.sociaTalla}` } }
                        : prev
                    );
                }
            }
        } catch (e) {
            // Evitar romper la UI por un fallo de carga de talla
            console.debug('No se pudo cargar la talla para la socia', partner?.id, e?.message);
        }
    };

    // Función para cerrar el modal de detalle de tratamiento
    const handleCloseTratamientoDetail = () => {
        setShowTratamientoDetailModal(false);
        setSelectedTratamiento(null);
    };

    // Función para cerrar el modal y limpiar datos
    const handleCloseDetailModal = () => {
        setShowDetailModal(false);
        setSelectedPartner(null);
        setTratamientos([]);
        setLoadingTratamientos(false);
        setShowTallaModal(false);
    };

    // Función para cerrar el modal de tratamiento
    const handleCloseTratamientoModal = () => {
        setShowTratamientoModal(false);
    };

    // Función para manejar cuando se crea/actualiza un tratamiento exitosamente
    const handleTratamientoCreated = async () => {
        setShowTratamientoModal(false);
        setSelectedTratamiento(null); // Limpiar tratamiento seleccionado
        // Si hay un partner seleccionado en el modal de detalle, actualizar sus tratamientos
        if (showDetailModal && selectedPartner) {
            await loadTratamientos(selectedPartner.id);
        }
    };

    // Función para abrir el modal de solicitud de ingreso
    const handleShowSolicitudIngreso = () => {
        setShowSolicitudIngresoModal(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('¿Está seguro de que desea desactivar esta socia?')) return;
        try {
            await sociasApiService.updateEstado(id, 'Inactivo');
            // Actualizar el estado local
            setPartners(prev => prev.map(p => 
                p.id === id ? { ...p, datosMedicos: { ...p.datosMedicos, estado: 'Inactivo' } } : p
            ));
        } catch (error) {
            console.error('Error al desactivar socia:', error);
            alert('Error al desactivar la socia');
        }
    };

    const handleActivate = async (id) => {
        if (!window.confirm('¿Está seguro de que desea activar esta socia?')) return;
        try {
            await sociasApiService.updateEstado(id, 'Activo');
            // Actualizar el estado local
            setPartners(prev => prev.map(p => 
                p.id === id ? { ...p, datosMedicos: { ...p.datosMedicos, estado: 'Activo' } } : p
            ));
        } catch (error) {
            console.error('Error al activar socia:', error);
            alert('Error al activar la socia');
        }
    };

    if (loading) return (
        <div className="loading-container">
            <i className="fas fa-spinner fa-spin"></i>
            <p>Cargando socias...</p>
        </div>
    );


    // Eliminado bloque de error: 'error' no está definido

    // Helpers de presentación
    const renderSiNo = (value) => {
        if (value === null || value === undefined) return 'No especificado';
        if (typeof value === 'boolean') return value ? 'Sí' : 'No';
        const str = String(value).trim().toLowerCase();
        if (str === '1' || str === 'si' || str === 'sí' || str === 'true') return 'Sí';
        if (str === '0' || str === 'no' || str === 'false') return 'No';
        const n = Number(value);
        if (!Number.isNaN(n)) return n === 1 ? 'Sí' : 'No';
        return 'No especificado';
    };

    const renderPercent = (value) => {
        if (value === null || value === undefined || value === '') return 'No especificado';
        const str = String(value).trim();
        const num = parseFloat(str.replace('%', '').replace(',', '.'));
        if (Number.isNaN(num)) return 'No especificado';
        // Si viene fraccionario (0–1), interpretarlo como 0%–100%
        const normalized = (num > 0 && num <= 1) ? (num * 100) : num;
        const pretty = Number.isInteger(normalized) ? normalized : parseFloat(normalized.toFixed(2));
        return `${pretty}%`;
    };

    const renderDate = (value) => {
        if (!value) return 'No especificado';
        try {
            const d = new Date(value);
            if (!Number.isNaN(d.getTime())) {
                try {
                    return d.toLocaleDateString('es-EC', { timeZone: 'America/Guayaquil', year: 'numeric', month: '2-digit', day: '2-digit' });
                } catch (_) {
                    return d.toISOString().slice(0, 10);
                }
            }
            const only = String(value).slice(0, 10);
            return /^\d{4}-\d{2}-\d{2}$/.test(only) ? only : 'No especificado';
        } catch (e) {
            return 'No especificado';
        }
    };

    return (
        <div className="content-container">
            <div className="page-header">
                <div className="header-title">
                    <h1>Gestión de Socias</h1>
                    <p>Administra el registro y la información de las socias</p>
                </div>
            </div>

            <div className="actions-container">
                <div className="search-section">
                    <div className="search-input">
                        <input
                            type="text"
                            placeholder="Buscar por nombre, cédula o código de socia..."
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                        <button type="button" title="Buscar">
                            <i className="fas fa-search"></i>
                        </button>
                    </div>
                </div>
                
                <div className="main-actions-group">
                    {/* Editar formato moved to dedicated module; button removed from partners area */}
                    <button className="btn-primary create-btn" onClick={handleAddPartner}>
                        <i className="fas fa-plus"></i>
                        Registrar Socia
                    </button>
                </div>
            </div>

            <div className="table-container">
                <table className="data-table partners-table">
                    <thead className="partners-table-head">
                        <tr>
                            <th>Código</th>
                            <th>Nombre y Cédula</th>
                            <th>Edad</th>
                            <th>Tipo Síndrome</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedPartners.map(partner => (
                            <tr key={partner.id}>
                                <td><span className="code-id-field">{partner.id}</span></td>
                                <td>
                                    <div className="name-cell">
                                        <span className="full-name">
                                            {`${partner.datosPersonales.nombres} ${partner.datosPersonales.apellidos}`}
                                        </span>
                                        <span className="cedula">
                                            CI: {partner.datosPersonales.cedula}
                                        </span>
                                    </div>
                                </td>
                                <td>{partner.datosPersonales.edad} años</td>
                                <td>
                                    <div className="syndrome-cell">
                                        <span className="syndrome-type">
                                            {partner.datosMedicos.tipoSindrome}
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <span className={`status-badge ${partner.datosMedicos.estado.toLowerCase()}`}>
                                        {partner.datosMedicos.estado}
                                    </span>
                                </td>
                                <td className="actions-cell">
                                    <button 
                                        className="action-btn"
                                        onClick={() => handleShowDetails(partner)}
                                        title="Ver detalles"
                                    >
                                        <i className="fas fa-eye"></i>
                                    </button>
                                    <button 
                                        className="action-btn"
                                        onClick={() => handleEdit(partner.id)}
                                        title="Editar"
                                    >
                                        <i className="fas fa-edit"></i>
                                    </button>
                                    {partner.datosMedicos.estado === 'Activo' ? (
                                        <button 
                                            className="action-btn delete-btn"
                                            onClick={() => handleDelete(partner.id)}
                                            title="Desactivar"
                                        >
                                            <i className="fas fa-ban"></i>
                                        </button>
                                    ) : (
                                        <button 
                                            className="action-btn activate-btn"
                                            onClick={() => handleActivate(partner.id)}
                                            title="Activar"
                                        >
                                            <i className="fas fa-check-circle"></i>
                                        </button>
                                    )}

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="records-info" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
                <div>
                    Mostrando <strong>{paginatedPartners.length}</strong> de <strong>{total}</strong> socias
                    ({partners.filter(p => p.datosMedicos.estado === 'Activo').length} activas)
                </div>
                <div className="pagination-controls" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <button className="btn-secondary" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}>Anterior</button>
                    <span> Página <strong>{page}</strong> de <strong>{totalPages}</strong> </span>
                    <button className="btn-secondary" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}>Siguiente</button>
                    <label style={{ marginLeft: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <span>Por página:</span>
                        <select value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}>
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                        </select>
                    </label>
                </div>
            </div>

            {showDetailModal && selectedPartner && (
                <div className="modal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h2>Información Detallada de la Socia <span className="code-id-field">{selectedPartner.id}</span></h2>
                            <button onClick={handleCloseDetailModal} className="close-btn">
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            {/* Botones de acción para la socia */}
                            <div className="socia-actions-group">
                                <button className="socia-action-btn" onClick={() => setShowRequisitosModal(true)}>
                                    Requisitos
                                </button>
                                <button className="socia-action-btn" onClick={() => setShowRasgosModal(true)}>
                                    Rasgos
                                </button>
                                <button className="socia-action-btn" onClick={() => handleNavigateToTratamientos(selectedPartner)}>Tratamiento</button>
                                <button className="socia-action-btn" onClick={handleShowSolicitudIngreso}>Inscripción</button>
                                {/* Botón Carnet para socias y admins (flujo actual) */}
                                <button
                                    className="socia-action-btn"
                                    onClick={async () => {
                                        if (!selectedPartner) return;
                                        setCarnetLoading(true);
                                        setCarnetBlob(null);
                                        try {
                                            const basePayload = {
                                                nombre: `${selectedPartner.datosPersonales.nombres} ${selectedPartner.datosPersonales.apellidos}`,
                                                cedula: selectedPartner.datosPersonales.cedula,
                                                nacionalidad: selectedPartner.datosPersonales.nacionalidad,
                                                sociaId: selectedPartner.id,
                                            };
                                            // Socia: generar directo sin pedir datos de directora
                                            const fmt = await carnetService.ensureFormatExists();
                                            if (!fmt.ok) {
                                                alert('El formato del carnet aún no está configurado. Solicite a la administradora que registre los datos de la directora y el logo.');
                                                return;
                                            }
                                            const result = await carnetService.generateCarnetPdf(basePayload);
                                            if (result.success) {
                                                setCarnetBlob(result.blob);
                                                setShowCarnetModal(true);
                                            } else {
                                                alert(result.error || 'No se pudo generar el carnet');
                                            }
                                        } catch (e) {
                                            console.error(e);
                                            alert('Error inesperado al generar carnet');
                                        } finally {
                                            setCarnetLoading(false);
                                        }
                                    }}
                                    disabled={carnetLoading}
                                >
                                    {carnetLoading ? 'Generando…' : 'Carnet'}
                                </button>
                                {/* Botón solo para admins: Editar Carnet */}
                                {/* Botón Editar Carnet movido afuera, solo admins */}
                                <button className="socia-action-btn" onClick={() => setShowTallaModal(true)}>
                                    Registrar/Ver Tallas
                                </button>
                                {selectedPartner.datosMedicos?.linkDocumentos && (
                                    <button
                                        type="button"
                                        className="socia-action-btn"
                                        onClick={() => window.open(selectedPartner.datosMedicos.linkDocumentos, '_blank', 'noopener,noreferrer')}
                                    >
                                        Ver Documentos
                                    </button>
                                )}
                            </div>

                            {/* Modal flotante de requisitos */}
                            {showRequisitosModal && (
                                <div className="modal" style={{zIndex: 2000}}>
                                    <div className="modal-content" style={{maxWidth: 500}}>
                                        <div className="modal-header" style={{background:'#821C53',borderTopLeftRadius:12,borderTopRightRadius:12,padding:'1.5rem 2rem 1.1rem 2rem',margin:'-1.2rem -1.2rem 1.2rem -1.2rem',boxSizing:'border-box'}}>
                                            <h3 style={{color:'#fff',margin:'0 0 0.2em 0',fontWeight:700,fontSize:'1.25rem',letterSpacing:'0.01em',lineHeight:'1.2'}}>Requisitos / Documentos</h3>
                                            <button onClick={() => {
                                                setShowRequisitosModal(false);
                                                setEditRequisitos(false);
                                            }} className="close-btn" style={{color:'#fff',top:10,right:16}}>
                                                <i className="fas fa-times"></i>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            {loadingRequisitos ? (
                                                <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
                                                    <i className="fas fa-spinner fa-spin"></i> Cargando requisitos...
                                                </div>
                                            ) : (
                                                <>
                                                    <div style={{ margin: '0.7rem 0 1.2rem 0', display: 'grid', gridTemplateColumns: '1fr', gap: '0.7rem 0' }}>
                                                        {requisitos.length === 0 ? (
                                                            <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
                                                                No hay requisitos registrados en el sistema.
                                                            </div>
                                                        ) : (
                                                            requisitos.map(req => {
                                                                const entregados = editRequisitos
                                                                    ? tempRequisitos
                                                                    : (selectedPartner.requisitosEntregados || []);
                                                                const isEntregado = entregados.includes(req.id);
                                                                const handleCheck = () => {
                                                                    if (!editRequisitos) return;
                                                                    setTempRequisitos(prev =>
                                                                        isEntregado
                                                                            ? prev.filter(rid => rid !== req.id)
                                                                            : [...prev, req.id]
                                                                    );
                                                                };
                                                                return (
                                                                    <label key={req.id} style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', fontSize: '1rem', color: isEntregado ? '#218838' : '#888', cursor: editRequisitos ? 'pointer' : 'default', userSelect: 'none' }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={isEntregado}
                                                                            onChange={handleCheck}
                                                                            disabled={!editRequisitos}
                                                                            style={{ accentColor: '#821C53', width: 18, height: 18 }}
                                                                        />
                                                                        <span>{req.nombre}</span>
                                                                    </label>
                                                                );
                                                            })
                                                        )}
                                                    </div>
                                                </>
                                            )}
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: 24 }}>
                                                {!editRequisitos ? (
                                                    <button className="btn-primary" onClick={() => {
                                                        setEditRequisitos(true);
                                                        setTempRequisitos(selectedPartner.requisitosEntregados ? [...selectedPartner.requisitosEntregados] : []);
                                                    }}>Editar</button>
                                                ) : (
                                                    <>
                                                        <button className="btn-primary" onClick={async () => {
                                                            try {
                                                                const sociaId = selectedPartner.id;
                                                                const originales = Array.isArray(selectedPartner.requisitosEntregados) ? selectedPartner.requisitosEntregados : [];
                                                                const nuevos = Array.isArray(tempRequisitos) ? tempRequisitos : [];
                                                                const setOriginal = new Set(originales);
                                                                const setNuevo = new Set(nuevos);
                                                                const aAgregar = nuevos.filter(id => !setOriginal.has(id));
                                                                const aEliminar = originales.filter(id => !setNuevo.has(id));

                                                                // Ejecutar llamadas en secuencia para control simple
                                                                for (const reqId of aAgregar) {
                                                                    await sociasRequisitosService.addRequisito(sociaId, reqId);
                                                                }
                                                                for (const reqId of aEliminar) {
                                                                    await sociasRequisitosService.removeRequisito(sociaId, reqId);
                                                                }

                                                                // Refrescar desde backend para quedar consistentes
                                                                const entregadosRes = await sociasRequisitosService.listBySocia(sociaId);
                                                                const nombresEntregados = Array.isArray(entregadosRes)
                                                                    ? entregadosRes.map(r => r.REQUISITOS_NOMBRE || r.requisito || r.nombre).filter(Boolean)
                                                                    : [];
                                                                const mapNombreAId = new Map(requisitos.map(r => [r.nombre, r.id]));
                                                                const idsEntregados = nombresEntregados.map(n => mapNombreAId.get(n)).filter(Boolean);

                                                                setPartners(prev => prev.map(socia =>
                                                                    socia.id === sociaId
                                                                        ? { ...socia, requisitosEntregados: idsEntregados }
                                                                        : socia
                                                                ));
                                                                setSelectedPartner(prev => prev ? { ...prev, requisitosEntregados: idsEntregados } : prev);
                                                                setEditRequisitos(false);
                                                                alert('Requisitos guardados');
                                                            } catch (e) {
                                                                console.error('Error guardando requisitos:', e);
                                                                alert((e?.response?.data?.message) || 'No se pudo guardar. Verifique conexión y que la socia exista.');
                                                            }
                                                        }}>Guardar</button>
                                                        <button className="btn-secondary" onClick={() => setEditRequisitos(false)}>Cancelar</button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Modal flotante de rasgos/características (carga real) */}
                            {showRasgosModal && (
                                <div className="modal" style={{zIndex: 2000}}>
                                    <div className="modal-content" style={{maxWidth: 600}}>
                                        <div className="modal-header" style={{background:'#821C53',borderTopLeftRadius:12,borderTopRightRadius:12,padding:'1.7rem 2.2rem 1.1rem 2.2rem',margin:'-1.2rem -1.2rem 1.2rem -1.2rem',boxSizing:'border-box'}}>
                                            <h3 style={{color:'#fff',margin:'0 0 0.2em 0',fontWeight:700,fontSize:'1.35rem',letterSpacing:'0.01em',lineHeight:'1.2'}}>Características del Síndrome</h3>
                                            <button onClick={() => setShowRasgosModal(false)} className="close-btn" style={{color:'#fff',top:10,right:16}}>
                                                <i className="fas fa-times"></i>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div style={{ margin: '0.7rem 0 1.2rem 0', display: 'grid', gridTemplateColumns: '1fr', gap: '0.7rem 0' }}>
                                                {caracteristicas.length === 0 ? (
                                                    <span style={{color:'#888'}}>No hay características registradas.</span>
                                                ) : (
                                                    caracteristicas.map(carac => {
                                                        const presentes = editRasgos
                                                            ? tempRasgos.map(String)
                                                            : (selectedPartner.caracteristicasPresentes || []).map(String);
                                                        const isPresente = presentes.includes(carac.id);
                                                        const handleCheck = (id) => {
                                                            if (!editRasgos) return;
                                                            setTempRasgos(prev => {
                                                                const arr = prev.map(String);
                                                                return arr.includes(id)
                                                                    ? arr.filter(cid => cid !== id)
                                                                    : [...arr, id];
                                                            });
                                                        };
                                                        return (
                                                            <label key={carac.id} style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', fontSize: '1rem', color: isPresente ? '#218838' : '#888', background: '#f8f6fa', borderRadius: 7, padding: '0.7rem 1rem', cursor: editRasgos ? 'pointer' : 'default', userSelect: 'none' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isPresente}
                                                                    onChange={() => handleCheck(carac.id)}
                                                                    disabled={!editRasgos}
                                                                    style={{ accentColor: '#821C53', width: 18, height: 18 }}
                                                                />
                                                                <span style={{ fontWeight: 600 }}>{carac.nombre}</span>
                                                                {carac.observacion && <span style={{ color: '#555', fontSize: '0.97em', marginLeft: 8 }}>{carac.observacion}</span>}
                                                            </label>
                                                        );
                                                    })
                                                )}
                                                {/* Botones de edición para rasgos */}
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: 24 }}>
                                                    {!editRasgos ? (
                                                        <button className="btn-primary" onClick={() => {
                                                            setEditRasgos(true);
                                                            setTempRasgos(selectedPartner.caracteristicasPresentes ? [...selectedPartner.caracteristicasPresentes] : []);
                                                        }}>Editar</button>
                                                    ) : (
                                                        <>
                                                            <button className="btn-primary" onClick={async () => {
                                                                if (!selectedPartner || !selectedPartner.id) return;
                                                                const sociaId = selectedPartner.id;
                                                                try {
                                                                    const originales = Array.isArray(selectedPartner.caracteristicasPresentes) ? selectedPartner.caracteristicasPresentes.map(String) : [];
                                                                    const nuevos = Array.isArray(tempRasgos) ? tempRasgos.map(String) : [];
                                                                    const setOriginal = new Set(originales);
                                                                    const setNuevo = new Set(nuevos);
                                                                    const aAgregar = nuevos.filter(id => !setOriginal.has(id));
                                                                    const aEliminar = originales.filter(id => !setNuevo.has(id));

                                                                    // Llamadas al backend para persistir cambios
                                                                    for (const cid of aAgregar) {
                                                                        await sociasCaracteristicasService.addCaracteristica(sociaId, cid);
                                                                    }
                                                                    for (const cid of aEliminar) {
                                                                        await sociasCaracteristicasService.removeCaracteristica(sociaId, cid);
                                                                    }

                                                                    // Refrescar desde backend la lista de características (devuelve nombres)
                                                                    const caracteristicasEntregadas = await sociasCaracteristicasService.listBySocia(sociaId);
                                                                    // Mapear nombres a ids usando el catálogo cargado en el modal
                                                                    const mapNombreAId = new Map((caracteristicas || []).map(c => [String(c.nombre), String(c.id)]));
                                                                    const idsEntregados = Array.isArray(caracteristicasEntregadas)
                                                                        ? caracteristicasEntregadas.map(it => it.CARACTERISTICA_NOMBRE || it.nombre || it.caracteristica || it.NOMBRE).map(n => mapNombreAId.get(n)).filter(Boolean)
                                                                        : [];

                                                                    // Actualizar estado local con valores persistidos
                                                                    setPartners(prev => prev.map(socia =>
                                                                        socia.id === sociaId
                                                                            ? { ...socia, caracteristicasPresentes: idsEntregados }
                                                                            : socia
                                                                    ));
                                                                    setSelectedPartner(prev => prev ? { ...prev, caracteristicasPresentes: idsEntregados } : prev);
                                                                    setEditRasgos(false);
                                                                    alert('Características guardadas');
                                                                } catch (e) {
                                                                    console.error('Error guardando características:', e);
                                                                    alert((e?.response?.data?.message) || 'No se pudo guardar. Verifique conexión y que la socia exista.');
                                                                }
                                                            }}>Guardar</button>
                                                            <button className="btn-secondary" onClick={() => setEditRasgos(false)}>Cancelar</button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="detail-section">
                                <h3>Datos Médicos Prioritarios</h3>
                                <div className="detail-grid">
                                    <div className="detail-item">
                                        <label>Tipo de Síndrome:</label>
                                        <span>{selectedPartner.datosMedicos?.tipoSindrome || 'No especificado'}</span>
                                    </div>
                                    <div className="detail-item">
                                        <label>Estado:</label>
                                        <span className={`status-badge ${selectedPartner.datosMedicos?.estado?.toLowerCase?.()}`}>{selectedPartner.datosMedicos?.estado || 'No especificado'}</span>
                                    </div>
                                    <div className="detail-item"><label>Padece Síndrome:</label><span>{selectedPartner.datosMedicos?.padeceSindrome || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Fecha de Inscripción:</label><span>{renderDate(selectedPartner.datosMedicos?.fechaInscripcion)}</span></div>
                                    <div className="detail-item"><label>Cariotipo:</label><span>{selectedPartner.datosMedicos?.cariotipo || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Carnet de Discapacidad:</label><span>{renderSiNo(selectedPartner.datosMedicos?.carnetDiscapacidad)}</span></div>
                                    <div className="detail-item"><label>Porcentaje:</label><span>{renderPercent(selectedPartner.datosMedicos?.porcentajeDiscapacidad)}</span></div>
                                    <div className="detail-item"><label>Tipo de Discapacidad:</label><span>{selectedPartner.datosMedicos?.tipoDiscapacidad || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Grado:</label><span>{selectedPartner.datosMedicos?.grado || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>IESS:</label><span>{renderSiNo(selectedPartner.datosMedicos?.iees)}</span></div>
                                    <div className="detail-item"><label>Edad de Detección:</label><span>{selectedPartner.datosMedicos?.edadDeteccion || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Talla:</label><span>{selectedPartner.datosMedicos?.talla || selectedPartner.sociaTalla || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Hormona de Crecimiento:</label><span>{renderSiNo(selectedPartner.datosMedicos?.hormonaCrecimiento)}</span></div>
                                    <div className="detail-item"><label>Ministerio de Salud:</label><span>{renderSiNo(selectedPartner.datosMedicos?.msp)}</span></div>
                                    <div className="detail-item">
                                        <label>Mentor:</label>
                                        <span>{selectedPartner.datosMedicos?.mentor || 'No asignado'}</span>
                                    </div>
                                    <div className="detail-item">
                                        <label>Documentos:</label>
                                        {selectedPartner.datosMedicos?.linkDocumentos ? (
                                            <a href={selectedPartner.datosMedicos.linkDocumentos} target="_blank" rel="noopener noreferrer">
                                                Ver carpeta de documentos
                                            </a>
                                        ) : (
                                            <span>No hay enlace registrado</span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Sección de Tratamientos */}
                            <div className="detail-section">
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                    <h3>Datos del Tratamiento</h3>
                                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                                        <button 
                                            className="btn-secondary" 
                                            onClick={() => handleNavigateToTratamientos(selectedPartner)}
                                            style={{ fontSize: '0.8rem', padding: '0.5rem 1rem' }}
                                        >
                                            <i className="fas fa-plus"></i> Nuevo Tratamiento
                                        </button>
                                        {tratamientos.length > 0 && (
                                            <button 
                                                className="btn-secondary" 
                                                onClick={() => handleVerTodosTratamientos(selectedPartner)}
                                                style={{ fontSize: '0.8rem', padding: '0.5rem 1rem' }}
                                            >
                                                <i className="fas fa-list"></i> Ver Todos
                                            </button>
                                        )}
                                    </div>
                                </div>
                                
                                {loadingTratamientos ? (
                                    <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
                                        <i className="fas fa-spinner fa-spin"></i> Cargando tratamientos...
                                    </div>
                                ) : tratamientos.length > 0 ? (
                                    <div className="tratamientos-grid">
                                        {tratamientos.slice(0, 3).map((tratamiento) => (
                                            <div 
                                                key={tratamiento.id} 
                                                className="tratamiento-item" 
                                                onClick={() => handleVerDetalleTratamiento(tratamiento)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <div className="tratamiento-header">
                                                    <span className="tratamiento-id">{tratamiento.id}</span>
                                                    <span className={`estado-badge ${tratamiento.estado.toLowerCase().replace(' ', '-')}`}>
                                                        {tratamiento.estado}
                                                    </span>
                                                </div>
                                <div className="tratamiento-info">
                                                    <div style={{ marginBottom: '0.5rem' }}>
                                                        <strong>Medicamento{tratamiento.medicamentos && tratamiento.medicamentos.length > 1 ? 's' : ''}:</strong>
                                                        {tratamiento.medicamentos && tratamiento.medicamentos.length > 0 ? (
                                                            <ul style={{ margin: '0.25rem 0 0 0', paddingLeft: '1.5rem' }}>
                                                                {tratamiento.medicamentos.map((med, index) => (
                                                                    <li key={index} style={{ fontSize: '0.9rem', color: '#555' }}>
                                                                        {med.MEDICAMENTO_NOMBRE || med.medicamento_nombre} 
                                                                        ({med.MEDICAMENTO_CANTIDAD || med.medicamento_cantidad} {med.MEDICAMENTO_UNIDAD || med.medicamento_unidad || 'mg'})
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        ) : (
                                                            <span style={{ color: '#999', fontStyle: 'italic' }}> Sin medicamentos</span>
                                                        )}
                                                    </div>
                                                    <p><strong>Médico:</strong> {tratamiento.medico}</p>
                                                    <p><strong>Especialidad:</strong> {tratamiento.especialidad}</p>
                                                    <p><strong>Período:</strong> {partnerTratamientoService.formatearFecha(tratamiento.fechaInicio)} - {partnerTratamientoService.formatearFecha(tratamiento.fechaFin)}</p>
                                                    {tratamiento.descripcion && (
                                                        <p><strong>Descripción:</strong> {tratamiento.descripcion.length > 80 ? tratamiento.descripcion.substring(0, 80) + '...' : tratamiento.descripcion}</p>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                        {tratamientos.length > 3 && (
                                            <div className="tratamiento-item tratamiento-more">
                                                <div style={{ textAlign: 'center', padding: '2rem' }}>
                                                    <i className="fas fa-ellipsis-h" style={{ fontSize: '1.5rem', color: '#821C53', marginBottom: '0.5rem' }}></i>
                                                    <p>+{tratamientos.length - 3} tratamientos más</p>
                                                    <button 
                                                        className="btn-primary" 
                                                        onClick={() => handleVerTodosTratamientos(selectedPartner)}
                                                        style={{ fontSize: '0.8rem', padding: '0.5rem 1rem' }}
                                                    >
                                                        Ver Todos
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="no-tratamientos">
                                        <div style={{ textAlign: 'center', padding: '2rem', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px dashed #dee2e6' }}>
                                            <i className="fas fa-prescription-bottle-alt" style={{ fontSize: '2rem', color: '#6c757d', marginBottom: '1rem' }}></i>
                                            <p style={{ margin: '0 0 1rem 0', color: '#6c757d' }}>No hay tratamientos registrados para esta socia</p>
                                            <button 
                                                className="btn-primary" 
                                                onClick={() => handleNavigateToTratamientos(selectedPartner)}
                                                style={{ fontSize: '0.9rem' }}
                                            >
                                                <i className="fas fa-plus"></i> Crear Primer Tratamiento
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="detail-section">
                                <h3>Datos Personales</h3>
                                <div className="detail-grid">
                                    <div className="detail-item"><label>Nombres:</label><span>{selectedPartner.datosPersonales?.nombres || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Apellidos:</label><span>{selectedPartner.datosPersonales?.apellidos || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Cédula:</label><span>{selectedPartner.datosPersonales?.cedula || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Edad:</label><span>{selectedPartner.datosPersonales?.edad || 0} años</span></div>
                                    <div className="detail-item"><label>Fecha de Nacimiento:</label><span>{renderDate(selectedPartner.datosPersonales?.fechaNacimiento)}</span></div>
                                    <div className="detail-item"><label>Estado Civil:</label><span>{selectedPartner.datosPersonales?.estadoCivil || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Nacionalidad:</label><span>{selectedPartner.datosPersonales?.nacionalidad || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Profesión:</label><span>{selectedPartner.datosPersonales?.profesion || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Sexo:</label><span>{selectedPartner.datosPersonales?.sexo || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Tipo de Socio:</label><span>{selectedPartner.datosPersonales?.tipoSocio || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Foto:</label>{selectedPartner.datosPersonales?.foto ? (<img src={selectedPartner.datosPersonales.foto} alt="Foto" style={{maxWidth:'80px',borderRadius:'8px'}} />) : (<span>Sin foto</span>)}</div>
                                </div>
                            </div>

                            <div className="detail-section">
                                <h3>Datos de Ubicación</h3>
                                <div className="detail-grid">
                                    <div className="detail-item"><label>País:</label><span>{selectedPartner.datosUbicacion?.pais || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Ciudad/Distrito:</label><span>{selectedPartner.datosUbicacion?.ciudadDistrito || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Provincia/Región:</label><span>{selectedPartner.datosUbicacion?.provinciaRegion || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Sector/Barrio:</label><span>{selectedPartner.datosUbicacion?.sectorBarrio || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Dirección:</label><span>{selectedPartner.datosUbicacion?.direccion || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Correo Electrónico:</label><span>{selectedPartner.datosUbicacion?.correoElectronico || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Teléfono 1:</label><span>{selectedPartner.datosUbicacion?.telefono1 || 'No especificado'}</span></div>
                                    <div className="detail-item"><label>Teléfono 2:</label><span>{selectedPartner.datosUbicacion?.telefono2 || 'No especificado'}</span></div>
                                </div>
                            </div>

                            <div className="modal-actions">
                                <button 
                                    className="btn-primary"
                                    onClick={() => handleEdit(selectedPartner.id)}
                                >
                                    <i className="fas fa-edit"></i>
                                    Editar Información
                                </button>
                                <button 
                                    className="btn-secondary"
                                    onClick={handleCloseDetailModal}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* Modal de gestión de tallas */}
            {showTallaModal && selectedPartner && (
                <TallaModal
                    isOpen={showTallaModal}
                    onClose={() => setShowTallaModal(false)}
                    sociaId={selectedPartner.id}
                    sociaNombre={`${selectedPartner.datosPersonales.nombres} ${selectedPartner.datosPersonales.apellidos}`}
                    onTallaCreated={(newTalla) => {
                        try {
                            if (newTalla && newTalla.TALLA_CM) {
                                setSelectedPartner(prev => prev ? { ...prev, datosMedicos: { ...prev.datosMedicos, talla: `${newTalla.TALLA_CM} cm` } } : prev);
                            }
                        } catch (e) {
                            console.debug('Error actualizando talla localmente:', e?.message);
                        }
                    }}
                />
            )}

            {/* Modal de creación/edición de tratamiento */}
            {showTratamientoModal && selectedPartner && (
                <TratamientoModal
                    isOpen={showTratamientoModal}
                    onClose={() => {
                        handleCloseTratamientoModal();
                        setSelectedTratamiento(null); // Limpiar tratamiento seleccionado
                    }}
                    onTratamientoCreated={handleTratamientoCreated}
                    pacienteId={selectedPartner.id}
                    pacienteNombre={`${selectedPartner.datosPersonales.nombres} ${selectedPartner.datosPersonales.apellidos}`}
                    tratamientoToEdit={selectedTratamiento} // Pasar el tratamiento si existe (para edición)
                />
            )}

            {/* Modal de carnet */}
            {showCarnetModal && (
                <CarnetModal
                    isOpen={showCarnetModal}
                    onClose={() => setShowCarnetModal(false)}
                    pdfBlob={carnetBlob}
                    filename={`carnet-${selectedPartner?.id || 'socia'}.pdf`}
                />
            )}

            {/* Modal para capturar Directora (nombre y cédula) */}
            {isAdmin && showCarnetDirectorModal && (
                <CarnetDirectorModal
                    isOpen={showCarnetDirectorModal}
                    onClose={() => setShowCarnetDirectorModal(false)}
                    onConfirm={async ({ nombreDirectora, cedulaDirectora, logoFile }) => {
                        setShowCarnetDirectorModal(false);
                        setCarnetLoading(true);
                        try {
                            // Solo guardar los datos del formato, no generar carnet
                            const res = await carnetService.createFormat({ nombreDirectora, cedulaDirectora, logoFile });
                            if (res?.success) {
                                alert('Formato de carnet actualizado correctamente.');
                            } else {
                                alert(res?.error || 'No se pudo guardar el formato');
                            }
                        } catch (err) {
                            alert('Error inesperado al guardar el formato');
                        } finally {
                            setCarnetLoading(false);
                        }
                    }}
                />
            )}

            {/* Modal para crear Formato de Carnet (logo + directora) */}
            {isAdmin && showFormatModal && (
                <FormatCarnetModal
                    isOpen={showFormatModal}
                    onClose={() => setShowFormatModal(false)}
                    onCreated={async () => {
                        // Reintentar generación si hay acción pendiente
                        const pending = pendingCarnetRef.current;
                        if (!pending) return;
                        setCarnetLoading(true);
                        try {
                            const result = await carnetService.generateCarnetPdf(pending.payload);
                            if (result.success) {
                                setCarnetBlob(result.blob);
                                setShowCarnetModal(true);
                                pendingCarnetRef.current = null;
                            } else {
                                alert(result.error || 'No se pudo generar el carnet tras crear el formato');
                            }
                        } finally {
                            setCarnetLoading(false);
                        }
                    }}
                    createFn={carnetService.createFormat}
                />
            )}

            {/* Modal de detalle de tratamiento */}
            {showTratamientoDetailModal && selectedTratamiento && (
                <div className="modal" style={{ display: 'flex', zIndex: 3000 }}>
                    <div className="modal-content" style={{ maxWidth: '600px', width: '90%' }}>
                        <div className="modal-header">
                            <h2>
                                <FaPills style={{ marginRight: '0.5rem' }} />
                                Detalle del Tratamiento {selectedTratamiento.id}
                            </h2>
                            <button onClick={handleCloseTratamientoDetail} className="close-btn" title="Cerrar">
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                <div className="info-section">
                                    <h3 style={{ color: '#821C53', marginBottom: '0.75rem', fontSize: '1.1rem' }}>
                                        <FaPills style={{ marginRight: '0.5rem' }} />
                                        Medicamentos
                                    </h3>
                                    {selectedTratamiento.medicamentos && selectedTratamiento.medicamentos.length > 0 ? (
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                            {selectedTratamiento.medicamentos.map((med, index) => (
                                                <div 
                                                    key={index}
                                                    style={{ 
                                                        padding: '0.75rem', 
                                                        backgroundColor: '#f8f9fa', 
                                                        borderRadius: '6px',
                                                        border: '1px solid #e9ecef'
                                                    }}
                                                >
                                                    <p style={{ margin: 0, fontWeight: '600', color: '#333' }}>
                                                        {index + 1}. {med.MEDICAMENTO_NOMBRE || med.medicamento_nombre}
                                                    </p>
                                                    <p style={{ margin: '0.25rem 0 0 0', color: '#666', fontSize: '0.9rem' }}>
                                                        Cantidad: {med.MEDICAMENTO_CANTIDAD || med.medicamento_cantidad} {med.MEDICAMENTO_UNIDAD || med.medicamento_unidad || 'mg'}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <p style={{ color: '#999', fontStyle: 'italic' }}>Sin medicamentos registrados</p>
                                    )}
                                </div>

                                <div className="info-section">
                                    <h3 style={{ color: '#821C53', marginBottom: '0.75rem', fontSize: '1.1rem' }}>
                                        <FaUserMd style={{ marginRight: '0.5rem' }} />
                                        Información Médica
                                    </h3>
                                    <p><strong>Médico:</strong> {selectedTratamiento.medico}</p>
                                    <p><strong>Especialidad:</strong> {selectedTratamiento.especialidad}</p>
                                </div>

                                <div className="info-section">
                                    <h3 style={{ color: '#821C53', marginBottom: '0.75rem', fontSize: '1.1rem' }}>
                                        <FaCalendarAlt style={{ marginRight: '0.5rem' }} />
                                        Período del Tratamiento
                                    </h3>
                                    <p><strong>Inicio:</strong> {partnerTratamientoService.formatearFecha(selectedTratamiento.fechaInicio)}</p>
                                    <p><strong>Fin:</strong> {partnerTratamientoService.formatearFecha(selectedTratamiento.fechaFin)}</p>
                                    <p>
                                        <strong>Estado:</strong> 
                                        <span className={`estado-badge ${selectedTratamiento.estado.toLowerCase().replace(' ', '-')}`} style={{ marginLeft: '0.5rem' }}>
                                            {selectedTratamiento.estado}
                                        </span>
                                    </p>
                                </div>

                                {selectedTratamiento.descripcion && (
                                    <div className="info-section">
                                        <h3 style={{ color: '#821C53', marginBottom: '0.75rem', fontSize: '1.1rem' }}>
                                            Descripción e Instrucciones
                                        </h3>
                                        <p style={{ whiteSpace: 'pre-wrap', backgroundColor: '#f8f9fa', padding: '0.75rem', borderRadius: '6px' }}>
                                            {selectedTratamiento.descripcion}
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer" style={{ justifyContent: 'space-between' }}>
                            <button 
                                onClick={() => {
                                    // Cerrar el modal de detalle y abrir el modal de edición
                                    handleCloseTratamientoDetail();
                                    // Preparar datos para edición
                                    const tratamientoParaEditar = {
                                        TRATAMIENTO_ID: selectedTratamiento.id,
                                        MEDICO_ID: selectedTratamiento.medicoId,
                                        PACIENTE_ID: selectedPartner.id,
                                        TRATAMIENTO_FECHA_INICIO: selectedTratamiento.fechaInicio,
                                        TRATAMIENTO_FECHA_FIN: selectedTratamiento.fechaFin,
                                        TRATAMIENTO_DESCRIPCION: selectedTratamiento.descripcion || '',
                                        medicamentos: selectedTratamiento.medicamentos || []
                                    };
                                    setSelectedTratamiento(tratamientoParaEditar);
                                    setShowTratamientoModal(true);
                                }} 
                                className="btn-primary"
                            >
                                <i className="fas fa-edit"></i> Editar Tratamiento
                            </button>
                            <button 
                                onClick={handleCloseTratamientoDetail} 
                                className="btn-secondary"
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Solicitud de Ingreso */}
            <SolicitudIngresoModal
                show={showSolicitudIngresoModal}
                onClose={() => setShowSolicitudIngresoModal(false)}
                socia={selectedPartner}
            />
    </div>
    );
};

export default PartnersList;